module.exports = __webpack_public_path__ + "img/plane-white.bd037a19.svg";